module.exports = __webpack_public_path__ + "img/21.47f37951.jpg";